<template>
  <base-editor-page id="builder-contacts">
    <template v-slot:description>
      <p>
        Create the people who put your story in motion. Your characters interact with your users. To
        make your story pop, write your emails and instant messages with them in mind. As an
        example, characters might be co-workers, clients, or relatives.
      </p>
    </template>

    <template v-slot:body>
      <contact-edit-modal
        :nameTagKey="selectedAuthor.nameTagKey"
        :title="selectedAuthor.title"
        :FK_authorThemeKey="selectedAuthor.FK_authorThemeKey"
        :authorKey="parseInt(selectedAuthor.authorKey)"
      />
      <add-button @click="handleAdd()" class="mb-25"> Add Character </add-button>

      <ul class="list-group mb-0">
        <li class="list-group-item">
          <div class="row">
            <div class="col-md-3">
              <strong>Name</strong>
            </div>
            <div class="col-md-3">
              <strong>Role (Job Title)</strong>
            </div>
            <div class="col-md-3">
              <strong>Icon Color</strong>
            </div>
          </div>
        </li>
      </ul>

      <ul class="list-group contacts-list">
        <li v-for="a in characters" :key="a.authorKey" class="list-group-item">
          <div class="row">
            <div class="col-md-3" data-cy="contact-name" data-testid="contact-name">
              {{ a.nameTagKey }}
            </div>
            <div class="col-md-3" data-cy="contact-title" data-testid="contact-title">
              {{ a.title }}
            </div>
            <div class="col-md-3" data-testid="contact-color">
              <template v-if="a.FK_authorThemeKey">
                <div
                  class="theme-color-selected mr-5"
                  :style="`background-color: ${
                    themes.length ? themes[a.FK_authorThemeKey - 1].backgroundColor : null
                  }`"
                ></div>
              </template>
              <template v-else> Random Color </template>
            </div>
            <div class="col-md-1 col-md-offset-2 action-icons">
              <span
                @click="handleDelete(a)"
                class="fas fa-trash-alt pull-right"
                data-testid="delete-character"
              ></span>
              <span
                @click="handleEdit(a.authorKey)"
                class="fas fa-pencil-alt pull-right mr-20"
                data-testid="edit-character"
              ></span>
            </div>
          </div>
        </li>
      </ul>
    </template>
  </base-editor-page>
</template>

<script>
  import BaseEditorPage from '@authoringPlatform/shared/BaseEditorPage.vue';
  import AddButton from '@authoringPlatform/shared/AddButton.vue';
  import ContactEditModal from './ContactEditModal';
  import { mapState, mapActions } from 'vuex';

  export default {
    name: 'Contacts',

    components: {
      BaseEditorPage,
      ContactEditModal,
      AddButton,
    },

    data: () => ({
      version: {},
      selectedAuthorKey: null,
    }),

    computed: {
      ...mapState('editMode/characters', ['characters', 'themes']),

      selectedAuthor() {
        if (this.selectedAuthorKey) {
          return this.characters[this.selectedAuthorKey];
        }
        return {};
      },
    },

    methods: {
      ...mapActions('editMode/characters', ['deleteAuthor']),
      ...mapActions(['notify']),

      handleAdd() {
        this.selectedAuthorKey = null;
        $('#contact-edit-modal').modal('show');
      },

      handleEdit(authorKey) {
        this.selectedAuthorKey = authorKey;
        $('#contact-edit-modal').modal('show');
      },
      async handleDelete({ questions, authorKey }) {
        if (questions && questions.size) {
          this.notify({
            message: 'Contact has emails/IMs assigned',
            isWarning: true,
          });
          return;
        }
        await this.deleteAuthor(authorKey);
      },
    },
  };
</script>

<style lang="scss">
  #builder-contacts {
    .action-icons {
      .fas {
        line-height: 1.42857;
        color: #333;
        &:hover {
          cursor: pointer;
          color: #000000;
        }
      }
    }

    .add-item {
      cursor: pointer;
      border: 1px dashed #afafaf;
    }

    .theme-color {
      height: 30px;
      width: 30px;
      margin: 3px;
    }
    .hover-theme {
      border: 2px solid #eaeaea;
      box-shadow: 1px 1px 1px #eaeaea;
    }
    .theme-color-selected {
      width: 20px;
      height: 20px;
    }
    .contacts-list {
      max-height: 50vh;
      overflow-y: auto;
      .list-group-item:first-of-type {
        border-top-style: none;
        border-top-left-radius: 0px;
        border-top-right-radius: 0px;
      }
    }
  }
</style>
